import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Tooltip, Modal } from 'antd';
import { store } from 'Store/store.index';
import { HOME_HEADER } from '@/constants/index'
import { /*PWA_INSTALL_STATUS,*/ SDK_FINISH_INIT } from 'Constants/app.constant';
import { INSTALL_BUTTON_CLICKS, TOOLS_GA_EVENT_LABEL } from 'Components/viewer/ui/constants/tools.constants';
import intl from 'react-intl-universal';
import { storageGetItem, storageSetItem, isParentNode, hasClass } from "Utils/utils";
import { isWindows, isMac } from '@/utils/device';
// import InstallPWAsLayer from './InstallPWAsLayer'
import './InstallPWAs.scss'
import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';

@inject('appStore', "userStore")
@observer
class InstallPWAs extends Component {
  constructor() {
    super()
    let pwa_show_tag = storageGetItem(localStorage, 'fx_pwa_show_tag');
    this.state = {
      isShowPwaLayer: !pwa_show_tag,
      visible: true,
      isInitUI: false,
      shadowVisible:false,
      isShowInstallModal: false
    }
    this.onClickInstal = this.onClickInstal.bind(this);
    this.onVisibleChange = this.onVisibleChange.bind(this);
    this.onClickTooltipLayer = this.onClickTooltipLayer.bind(this);
    this.onClickDomElement = this.onClickDomElement.bind(this);
    this.onAutoHideLayer = this.onAutoHideLayer.bind(this);
    this.onFinishLoadUI = this.onFinishLoadUI.bind(this);

    this.isAddSDKEvent = false;
  }
  componentDidMount() {
    // sdk是否加载完成
    if (store.appStore.isSDKFinishInit) {
      this.onFinishLoadUI();
    } else { 
      this.isAddSDKEvent = true;
      store.appStore.addAppEventListener(SDK_FINISH_INIT, this.onFinishLoadUI);
    }
    window.addEventListener('click', this.onClickDomElement);
    setTimeout(()=>{
      this.setState({
        shadowVisible:false,
        visible:false
      });
    },3000)
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.onClickDomElement);
    if (this.isAddSDKEvent) {
      store.appStore.removeAppEventListener(SDK_FINISH_INIT, this.onFinishLoadUI);
    }
  }
  onFinishLoadUI() {
    this.setState({
      isInitUI: true
    })
  }
  onClickDomElement(e) {
    //console.log('===>>> ~ InstallPWAs ~ onClickDomElement ~ e', e);
    //
    let node = document.getElementById('pwa-tooltip');
    if (!node) {
      return;
    }
    if (hasClass(node, 'ant-tooltip-hidden') || node == e.target || isParentNode(node, e.target)) {
      return;
    }

    this.onVisibleChange(false);
  }
  onClickInstal() {
    store.userStore.doSendGAEvent({  
      eventKey: INSTALL_BUTTON_CLICKS, 
      label: TOOLS_GA_EVENT_LABEL
    })
    this.onVisibleChange(false);
    //is Windows or is mac
    if(isWindows || isMac){
      store.appStore.setShowPluginInstall(true)
    } else {
      store.appStore.doInstallPWAs();
    }
  }

  onVisibleChange(visible) {
    if (this.state.isShowPwaLayer) {
      let pwa_show_tag = storageGetItem(localStorage, 'fx_pwa_show_tag')
      if (!pwa_show_tag) {
        pwa_show_tag = new Date().getTime();
        storageSetItem(localStorage, 'fx_pwa_show_tag', pwa_show_tag);
      }
    }

    this.setState({
      isShowPwaLayer: false,
      visible
    })
  }
  onClickTooltipLayer(e) {
    e && e.stopPropagation();
    e && e.preventDefault();
    this.onVisibleChange(false)
  }
  onMouseLeaveTooltip = (e) => {
    if (!e || !e.currentTarget) {
      return;
    }
    //console.log('onMouseLeaveTooltip:', e)
    if (!(e.relatedTarget instanceof HTMLElement)) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }

    return true;
  }
  onFocusTooltip = (e) => {
    console.log('onFocusTooltip:', e)
  }
  onAutoHideLayer(/* isAuto */) {
    this.onVisibleChange(false)
  }
  shadowClick=()=>{
    this.setState({
      shadowVisible:false
    })
  }

  showDownloadEditorCloudTipModal = () => {
    this.setState({
      isShowInstallModal: true
    })
  }
  hideDownloadEditorCloudTipModal = () => {
    this.setState({
      isShowInstallModal: false
    })
  }

  onGoForDownload = () => {
    this.hideDownloadEditorCloudTipModal();
    store.appStore.downloadEditorCloudApplication();
  }

  render() {
    if (isDTRuntime) return null;
    const { /*isShowPwaLayer, visible, */ isInitUI, /* shadowVisible, */ isShowInstallModal} = this.state;
    // const { hasSignIn, isShowSignUpDlg, isShowWelcomeDlg } = store.userStore;
    // const hasSignUp = !!isShowSignUpDlg && !hasSignIn && !isShowWelcomeDlg;
    const { /*beforeInstallPWAsEvent, PWAsInstallStatus,*/ headerType } = store.appStore;
    // const disabled = PWAsInstallStatus === PWA_INSTALL_STATUS.installing;

    // let isShowPWA;
    // if(isWindows || isMac){
    //  isShowPWA = isInitUI ;
    // }else{
    //  isShowPWA = isInitUI && beforeInstallPWAsEvent && PWAsInstallStatus !== PWA_INSTALL_STATUS.cancel;
    // }
    let isShowInstallBtn = isWindows || isMac;

    if (process.env.NODE_ENV == 'development') {
      return null;
    }
    if (headerType !== HOME_HEADER) {
      return null;
    }

    return (
      <>
        {
          (isShowInstallBtn)?
            (<Tooltip id='pwa-tooltip'/*  visible={(!isShowWelcomeDlg || !hasSignUp) && visible} */ trigger={'hover'}
              overlayClassName='pwa-tooltip' title={<div>
                {/* {shadowVisible && <div className='toolTipShadow' onClick={this.shadowClick}></div>} */}
                <div>{intl.get('HeaderContainer.EditorCloudDefaultViewerTooltip')}</div>
              </div>} placement={'bottomRight'}
              onVisibleChange={this.onVisibleChange} >
              <div id='pwa-install-wrapper' className='install-btn-wrapper' onClick={this.showDownloadEditorCloudTipModal}>
                {/* {isShowPwaLayer && <InstallPWAsLayer onMouseLeave={this.onMouseLeaveTooltip} onClick={this.onClickTooltipLayer} autoHideLayer={this.onAutoHideLayer} />} */}
                <Button id='pwa-install-core' disabled={!isInitUI} className='install-btn' type='link'></Button>
              </div>
            </Tooltip>)
            :null
        }
        {isShowInstallModal &&
          <Modal
            className='downloadEditorCloudAppModalInHome'
            title={intl.get('HeaderContainer.titleEditor')}
            visible={isShowInstallModal}
            cancelText={intl.get('Cancel')}
            okText={intl.get('HeaderContainer.DownloadApp')}
            onCancel= {this.hideDownloadEditorCloudTipModal}
            onOk={this.onGoForDownload}>
            <div className='downloadEditorCloudAppModalInHomeContainer'>
              <div className="installInfo-icon"></div>
              <div className="info-tip">
                <div className='main-tip'>{intl.get('HeaderContainer.InstallEditorCloudMainTip')}</div>
                <div className='sub-tip'>{intl.get('HeaderContainer.InstallEditorCloudSubTip')}</div>
              </div>
            </div>
          </Modal>
        }
      </>
    )
  }
}

export default InstallPWAs;